import React, { useEffect, useRef, useState } from 'react';
import { Box } from '@mui/material';
import AddEditFinanceForm from "./AddEditFinanceForm";
import FinanceList from "./financeList";
import './FinanceMgmt.css';
import { useAuth } from '../AuthContext';

const FinanceMgmt = () => {
    const { can } = useAuth(); const canCreate = can('FINANCE.CREATE'); const canEdit = can('FINANCE.EDIT');
    const [selectedRecord, setSelectedRecord] = useState(null);
    const [refreshKey, setRefreshKey] = useState(0);
    const formRef = useRef(null);

    useEffect(() => {
        if (selectedRecord) formRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, [selectedRecord]);

    const handleSaved = () => {
        setSelectedRecord(null);
        setRefreshKey((current) => current + 1);
    };

    const handleEdit = (record) => {
        setSelectedRecord(record);
    };

    return (
        <Box className={`finance-page ${canEdit ? '' : 'finance-read-only'}`}>
            <header className="finance-page-header">
                <div><p className="school-eyebrow">Accounts workspace</p><h2>Financial Record Management</h2><p>Track received funds and school expenditure with a clear, auditable register.</p></div>
                <span className="finance-header-mark">FR</span>
            </header>
            {(selectedRecord ? canEdit : canCreate) && <div ref={formRef} className="finance-form-anchor"><AddEditFinanceForm initialData={selectedRecord} onSaved={handleSaved} onCancel={() => setSelectedRecord(null)} /></div>}
            <FinanceList refreshKey={refreshKey} onEdit={canEdit ? handleEdit : null} />
        </Box>
    );
};

export default FinanceMgmt;
